export function Visualizer({ color, active }: { color: string; active: boolean }) {
  const barConfigs = [
    { duration: 0.4, delay: 0, minHeight: 15, maxHeight: 60 },
    { duration: 0.5, delay: 0.1, minHeight: 20, maxHeight: 80 },
    { duration: 0.35, delay: 0.15, minHeight: 25, maxHeight: 100 },
    { duration: 0.45, delay: 0.05, minHeight: 20, maxHeight: 90 },
    { duration: 0.5, delay: 0.2, minHeight: 15, maxHeight: 70 },
    { duration: 0.4, delay: 0.12, minHeight: 25, maxHeight: 85 },
    { duration: 0.55, delay: 0.08, minHeight: 20, maxHeight: 75 },
    { duration: 0.38, delay: 0.18, minHeight: 15, maxHeight: 65 },
  ];

  return (
    <div className="flex items-end gap-[2px] h-5">
      {barConfigs.map((config, i) => (
        <div
          key={i}
          className="w-[3px] rounded-full"
          style={{
            backgroundColor: color,
            height: active ? `${config.maxHeight}%` : "20%",
            animation: active
              ? `bar-dance-${i % 4} ${config.duration}s ease-in-out infinite`
              : "none",
            animationDelay: `${config.delay}s`,
            opacity: active ? 1 : 0.3,
            transition: "height 0.2s, opacity 0.2s",
          }}
        />
      ))}
    </div>
  );
}
